import { graphql } from "gatsby";
import React from "react";

import NumberedSliderVideo from "../components/NumberedSliderVideo";

const NumberedSliderParagraphVideo = ({ content }) => {
  const titles = content.map(({ title }) => title);
  const bodies = content.map(({ body }) => body.processed);
  const linkTitles = content.map(({ link }) => link.title);
  const linkUris = content.map(({ link }) => link.uri);
  const videos = content.map(({ video }) => video);

  //console.log(videos);
  const imageAlts = content.map(
    ({ relationships }) => relationships?.image?.field_image?.alt
  );
  const images = content.map(
    ({ relationships }) =>
      relationships?.image?.relationships?.field_image?.localFile
  );
  // console.log(images);
  const captions = content.map(
    ({ relationships }) => relationships?.image?.caption
  );

  const thumbnails = content.map(
    ({ relationships }) =>
      relationships?.thumbnail?.relationships?.field_image?.localFile.publicURL
  );

  return (
    <>
      <NumberedSliderVideo
        titles={titles}
        bodies={bodies}
        linkTitles={linkTitles}
        linkUris={linkUris}
        imageAlts={imageAlts}
        images={images}
        captions={captions}
        videos={videos}
        thumbnails={thumbnails}
      />
    </>
  );
};

export const query = graphql`
  fragment ParagraphNumberedSliderVideo on paragraph__numbered_slider {
    __typename
    id
    title: field_numbered_slider_title
    body: field_numbered_slider_body {
      processed
    }
    link: field_numbered_slider_link {
      title
      uri
    }
    video: field_numbered_slider_video
    relationships {
      image: field_numbered_slider_image {
        caption: field_caption
        field_image {
          alt
        }
        relationships {
          field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(aspectRatio: 1.5, layout: FULL_WIDTH)
              }
            }
          }
        }
      }
      thumbnail: field_numberedslider_thumbnail {
        relationships {
          field_image {
            localFile {
              publicURL
            }
          }
        }
      }
    }
  }
`;

export default NumberedSliderParagraphVideo;
